import jwtDecode from 'jwt-decode';

const JWT_TOKEN = 'JWT_TOKEN';

interface JwtToken {
  user_id: number;
  username: string;
  exp: number;
  email: string;
  orig_iat: number;
}

export function getJwtToken() {
  return localStorage.getItem(JWT_TOKEN);
}

export function setJwtToken(value: string) {
  return localStorage.setItem(JWT_TOKEN, value);
}

export function clearAuthLocalStorage() {
  localStorage.removeItem(JWT_TOKEN);
}

export function getCsrfToken(): string {
  const decodedCookie: string = decodeURIComponent(document.cookie);
  const matchArray: RegExpMatchArray | null = decodedCookie.match(/csrftoken=([\w\d]+)/);
  if (!matchArray) return '';

  return matchArray[1];
}

export function hasTokenExpired(token?: string | null): boolean {
  if (!token) return true;

  const decodedToken: JwtToken = jwtDecode(token);
  const { exp } = decodedToken;
  return (exp - (Date.now() / 1000)) <= 0;
}
